import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import AppsIcon from "@mui/icons-material/Apps";
import { useTranslation } from "react-i18next";
import { ThemeToggleButton } from "./ThemeToggleButton";
import { LanguageSelectorButton } from "./LanguageSelectorButton";
import { APP_NAME } from "../constants";

export const TopBar: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <LanguageSelectorButton />
          </Box>
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              alignItems: "center",
              borderRadius: 999,
              px: 2,
              py: 0.75,
            }}
            role="img"
            aria-label={t("topBar.app_aria", { defaultValue: "App name" })}
          >
            <AppsIcon sx={{ mr: 1 }} />
            <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
              {APP_NAME}
            </Typography>
          </Box>
          <Box sx={{ marginLeft: "auto" }}>
            <ThemeToggleButton />
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default TopBar;
